//////////////////////////////////////////////////////////////
//     							                                        //
//  Program: MasterAccommodationAgreementService.js         //
//  Application: MasterAccommodationAgreementService        //
//  Option: Used to manage the Master Accommodation         //
//          Agreement document                              //
//  Date: 2026-07-10                                        //
//                                                          //
//////////////////////////////////////////////////////////////

import ApiService from "./ApiService";

class MasterAccommodationAgreementService {
  getMasterAgreement() {
    let endPoint = "master-accommodation-agreement";
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  updateMasterAgreement(slug, data) {
    // Delete data which we don't want to send
    delete data.errors;
    delete data.input;

    let endPoint = "master-accommodation-agreement/" + slug;
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.putCall(inputData);
    return response;
  }
}

export default new MasterAccommodationAgreementService();
